const FdapnResponseApiUrls = {
    GET: `${process.env.REACT_APP_USER_FDA_PN_URL}/fda-pn/pn/transaction/get`
  };
  
  export default FdapnResponseApiUrls;
  